import { FORM_BUILDER_FIELD_TYPE } from "@loanbossinc/component-library";

import {
  shouldShowAmortizationStartDateEdit,
  shouldShowMonthlyPrincipalReductionEdit,
  shouldShowAmortizationTermEdit,
  shouldShowAmortizationRateEdit
} from "./section-amortization-row-logic";

export const rows = {
  title: {
    isTitle: true,
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TEXT,
        value: "Amortization",
        style: {
          marginLeft: "0",
          fontFamily: "Work Sans",
          fontStyle: "normal",
          fontWeight: "500",
          fontSize: "16px",
          lineHeight: "14px",
          textTransform: "uppercase",
          color: "#000000",
          marginBottom: "10px"
        }
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.amortization.header"
      }
    ]
  },
  amortizationType: {
    label: "Amortization Type",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        name: "amortizationDetails.amortizationTypeId",
        variant: "filled",
        displayWith: option => option.name,
        setValueWith: option => option.id,
        parentId: "amortizationTypes"
      }
    ]
  },
  amortizationTerm: {
    isVisible: data => shouldShowAmortizationTermEdit(data),
    label: "Amortization Term",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.NUMBER,
        name: "amortizationDetails.amortizationTerm",
        variant: "filled"
      }
    ]
  },
  amortizationStartDate: {
    isVisible: data => shouldShowAmortizationStartDateEdit(data),
    label: "Amortization Start Date",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DATE,
        name: "amortizationDetails.amortizationStartDate",
        variant: "filled"
      }
    ]
  },
  monthlyPrincipalReduction: {
    isVisible: data => shouldShowMonthlyPrincipalReductionEdit(data),
    label: "Monthly Principal Reduction",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DOLLAR,
        name: "amortizationDetails.monthlyPrincipalReduction",
        variant: "filled"
      }
    ]
  },
  amortizationRate: {
    isVisible: data => shouldShowAmortizationRateEdit(data),
    label: "Amortization Rate",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.PERCENT,
        name: "amortizationDetails.amortizationRate",
        variant: "filled",
        decimals: 3
      }
    ]
  },
  amortizationDetails: {
    label: "Amortization Details",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "amortizationDetails.amortization",
        variant: "filled"
      }
    ]
  },
  paymentDays: {
    label: "Payment Days",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.NUMBER,
        name: "details.paymentDay",
        variant: "filled"
      }
    ]
  },
  businessDayAdj: {
    label: "Payment Day Adj",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        name: "details.businessDayAdjustmentId",
        variant: "filled",
        parentId: "businessDayAdjustmentList",
        displayWith: option => option.name,
        setValueWith: option => option.value
      }
    ]
  },
  interestCalculation: {
    label: "Interest Calculation",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "amortizationDetails.interestCalculation",
        variant: "filled"
      }
    ]
  },
  calculationPeriods: {
    label: "Interest Only Periods",
    cells: [{
      type: FORM_BUILDER_FIELD_TYPE.NUMBER,
      name: "amortizationDetails.ioPeriod",
      variant: "filled",
      disabled: true
    }]
  },
  misc: {
    label: "Misc",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "amortizationDetails.amortMisc",
        multiline: true,
        variant: "filled"
      }
    ]
  }
};
